import { ErrorPage, InfoCardInner, LoadingPage, Modal } from '@chocolate-soup-inc/cs-frontend-components';
import { useMemo } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { EmployeeModal } from './EmployeeModal';

import { readableDate } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { toast } from 'react-toastify';
import { TEmployeeType, useQueryOneEmployee } from '../../entities/employees/queries';

export const EmployeeAccount = () => {
  const navigate = useNavigate();
  const { employeeId = '0' } = useParams();

  const {
    data: employee,
    error,
    loading
  } = useQueryOneEmployee({
    id: employeeId
  });

  const title = useMemo(() => {
    const fullName = employee?.fullName;
    if (fullName) return fullName;
    else return 'Employee Account';
  }, [employee]);

  if (loading)
    return (
      <Modal closeModal={() => navigate(generatePath('../../'))} headline={title}>
        <LoadingPage />
      </Modal>
    );

  if (error) {
    console.error('query Apollo ERROR:', error);
    toast.error('An error has ocurred, check the console for details. (query Apollo ERROR)');
    //if (error.message) toast.error(error.message);
    if (!employee)
      return (
        <Modal closeModal={() => navigate(generatePath('../../'))} headline={title}>
          <ErrorPage error={error} />
        </Modal>
      );
  }

  return (
    <EmployeeModal employee={employee} headline={title}>
      <div>
        <InfoCardInner<TEmployeeType>
          data={employee}
          sections={[
            //{ title: 'Information', columns: [] },
            {
              columns: [
                {
                  label: 'First Name',
                  accessor: 'firstName'
                },
                {
                  label: 'Preferred First Name',
                  accessor: 'preferredFirstName'
                },
                {
                  label: 'Last Name',
                  accessor: 'lastName'
                },
                {
                  label: 'Hire Date',
                  render: (data) => readableDate(data?.hireDate ?? undefined)
                },
                {
                  label: 'Custom Onboard Brick',
                  accessor: 'customOnboardBrick'
                }
              ]
            },
            {
              columns: [
                {
                  label: 'Company',
                  render: (data?) => data?.company?.name
                },
                {
                  label: 'Office',
                  render: (data?) => data?.office?.name
                },
                {
                  label: 'Date of Birth',
                  render: (data) => readableDate(data?.birthDate || undefined)
                },
                {
                  label: 'Email',
                  accessor: 'email'
                },
                {
                  label: 'Phone Number',
                  accessor: 'phoneNumber'
                }
              ]
            },
            {
              columns: [
                {
                  label: 'Allergies & Dietary Restrictions',
                  accessor: 'foodPreferences'
                }
              ]
            },
            {
              columns: [
                {
                  label: 'T-Shirt Size',
                  accessor: 'tShirtSize'
                },
                {
                  label: 'Sweater Size',
                  accessor: 'sweaterSize'
                }
              ]
            },
            {
              columns: [
                {
                  label: 'Address Line 1',
                  render: (data) => data?.address?.address1
                },
                {
                  label: 'Address Line 2',
                  render: (data) => data?.address?.address2
                },
                {
                  label: 'City',
                  render: (data) => data?.address?.city
                },
                {
                  label: 'State',
                  render: (data) => data?.address?.state
                },
                {
                  label: 'Country',
                  render: (data) => data?.address?.country
                },
                {
                  label: 'Zip Code',
                  render: (data) => data?.address?.zipCode
                }
              ]
            },
            {
              columns: [
                {
                  label: 'Donate Birthday Gifts to Charity',
                  render: (data) => (data?.donateBirthdayGift ? 'yes' : 'no')
                },
                {
                  label: 'Donate Work Anniversary Gifts to Charity',
                  render: (data) => (data?.donateWorkAnniversaryGift ? 'yes' : 'no')
                }
              ]
            }
          ]}
        />
      </div>
    </EmployeeModal>
  );
};
